import { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, Select, MenuItem, } from "@mui/material";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddAxles({
  open,
  onClose,
  setOpen,
}: ModalProps) {

  const [selectedCategories, setSelectedCategories] = useState<string[]>(["default"]);
  const categories = ["Car", "Bike", "Bicycle", "Caravan", "Trucks", "Heavy Equipment", "Spare Parts", "Car Accessories"];
  const handleCategoryChange = (event: any) => {
    const value = event.target.value as string[];
    if (value.length > 1 && value.includes("default")) {
      setSelectedCategories(value.filter(v => v !== "default"));
    } else {
      setSelectedCategories(value);
    }
  };

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Axles</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label htmlFor="axles-name">Axles</label>
              <TextField
                id="axles-name"
                placeholder="Enter Axles (e.g., 2 Axles)"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group">
              <label htmlFor="Category">Category</label>
              <Select
                multiple
                fullWidth
                hiddenLabel
                value={selectedCategories}
                onChange={handleCategoryChange}
                renderValue={(selected) =>
                  (selected as string[])
                    .filter(v => v !== "default")
                    .join(", ") || "Select Categories"
                }
              >
                <MenuItem value={"default"} disabled>Select Categories</MenuItem>
                {categories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
